import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { AUTO_FUND } from '../../constants/fund-type';
import { AddFundsContextProvider } from '../../context/add-funds-context-provider';
import { AutoFundModalBody } from './auto-fund-modal-body';
import { emptyObject } from 'ui-components/default-props/empty';
import ModalPortal from '../../../../../components/modal-portal';
import SubmitButton from '../funding/submit-button';
import { SurchargeInfoBanner } from '../../../../../financial-services-ui/surcharge/surcharge-info-banner';
import { useSurchargeInfoEligibility } from '../../../../../financial-services-ui/surcharge/hooks';

import messages from '../funding/messages';
import commonStyles from '../funding/style.module.less';
import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {string} props.sellerCurrencyCode
 * @param {() => void} props.onSuccess
 * @param {{threshold?: Currency, amount?: Currency, cutoff?: number}} [props.autoFundConfig]
 * @param {() => void} props.onSaveAutoFundConfig
 * @returns {JSX.Element}
 */
export const AutoFundingModal = ({ onClose, sellerCurrencyCode, onSuccess, autoFundConfig = emptyObject, onSaveAutoFundConfig }) => {
  const [submitting, setSubmitting] = useAsyncSafeState(false);
  const [saveIsDisabled, setSaveIsDisabled] = useAsyncSafeState(false);
  const { isEligible, surchargePercentage } = useSurchargeInfoEligibility(TransactionCategory.AddFunds);

  return (
    <AddFundsContextProvider
      autoFundConfig={autoFundConfig}
      currencyCode={sellerCurrencyCode}
      onSaveAutoFunding={onSaveAutoFundConfig}
      onSuccess={onSuccess}
      setSubmitting={setSubmitting}
      submitting={submitting}
    >
      <ModalPortal onClose={onClose}>
        <Modal className={styles.modal}>
          <ModalHeader className={styles.background}>
            <FormattedMessage {...messages.autoFundTitle} />
          </ModalHeader>
          <ModalBody>
            {isEligible && <SurchargeInfoBanner className={styles['surcharge-banner']} surchargeAmount={surchargePercentage} />}
            <AutoFundModalBody currencyCode={sellerCurrencyCode} saveIsDisabled={saveIsDisabled} setSaveIsDisabled={setSaveIsDisabled} />
          </ModalBody>
          <div className={styles['disclaimer-container']}>
            <div className={styles.disclaimer}>
              <FormattedMessage {...messages.disclaimer} />
            </div>
          </div>
          <ModalFooter className={styles.background}>
            <ModalFooterCancelButton className={commonStyles['button-border']} />
            <SubmitButton disabled={saveIsDisabled} fundType={AUTO_FUND}>
              <FormattedMessage {...messages.saveButton} />
            </SubmitButton>
          </ModalFooter>
        </Modal>
      </ModalPortal>
    </AddFundsContextProvider>
  );
};
